<template>
  <el-cascader
    class="operational-logic"
    :options="options"
    value-key="value"
    :props="{ checkStrictly: true, emitPath: false }"
    :show-all-levels="false"
    @change="hChange"
    :value="value.value"
    ref="c"
    collapse-tags
  ></el-cascader>
</template>

<script>
export default {
  props: {
    options: {
      default: () => []
    },
    value: {
      type: [Object, Array]
    }
  },
  methods: {
    hChange(v) {
      const { value, label } = this.$refs.c.getCheckedNodes()[0]
      this.$emit('input', { name: label, value })
    }
  }
}
</script>

<style></style>
